import { content_sv_SE_SKBV } from './content_sv_SE_SKBV';
import { content_nb_NO_GF } from './content_nb_NO_GF';
import { content_sv_FI_NR } from './content_sv_FI_NR';
import { content_fi_FI_NR } from './content_fi_FI_NR';

export const getLocalizationData = (channelId) => {
  let localizationObj = {
    language: '',
    marketCode: '',
    text: {},
  };

  switch (channelId) {
    case '1':
      // Skånska Byggvaror (Svenska)
      localizationObj.language = 'sv-SE';
      localizationObj.marketCode = 'SE-SKBV';
      localizationObj.text = content_sv_SE_SKBV;
      break;
    case '4':
      // Grønt Fokus (Norska, bokmål)
      localizationObj.language = 'nb-NO';
      localizationObj.marketCode = 'NO-GF';
      localizationObj.text = content_nb_NO_GF;
      break;
    case '7':
      // Nordrum (Svenska)
      localizationObj.language = 'sv-FI';
      localizationObj.marketCode = 'SE-NR';
      localizationObj.text = content_sv_FI_NR;
      break;
    case '8':
      // Nordrum (Finska)
      localizationObj.language = 'fi-FI';
      localizationObj.marketCode = 'FI-NR';
      localizationObj.text = content_fi_FI_NR;
      break;
    default:
      console.log(`Unexpected channelId: ${channelId}`);
  }

  return localizationObj;
};
